export default "__VITE_ASSET__Cu2pkZ5m__"